import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import React from "react";

const SimpleStatCard = ({
  title,
  amount,
  chip,
  percentageText,
  percentagecolor,
  isLoaded,
}) => {
  return (
    <Card>
      <CardContent>
        {isLoaded ? (
          <>
            <Typography variant="h6" mb={4}>
              {title}
            </Typography>
            <Typography variant="h3" mb={2}>
              <Box fontWeight="fontWeightRegular">{amount}</Box>
            </Typography>
            {percentagecolor && percentageText ? (
              <Typography
                variant="subtitle2"
                mb={6}
                color="textSecondary"
                percentagecolor={percentagecolor}
              >
                <span>{percentageText}</span> Since last week
              </Typography>
            ) : (
              <br />
            )}
            {chip && <Chip label={chip} />}
          </>
        ) : (
          <>
            <Skeleton variant="text" width="60%" height={32} sx={{ mb: 4 }} />
            <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
            <Skeleton variant="text" width="40%" height={24} sx={{ mb: 2 }} />
            {chip && <Skeleton variant="rounded" width={80} height={32} />}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default SimpleStatCard;
